import { render, staticRenderFns } from "./SubjectsCustomizingItem.vue?vue&type=template&id=73d9d63a&scoped=true"
import script from "./SubjectsCustomizingItem.vue?vue&type=script&lang=js"
export * from "./SubjectsCustomizingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d9d63a",
  null
  
)

export default component.exports